import { StateRoot } from "./types/VideoReduxState";

import { createStore, applyMiddleware, compose } from "redux";
import rootReducer from "./reducers/root";
import thunk from "redux-thunk";
import { isBrowser } from "./utils/EnvUtil";

function createMiddlewares() {
    const middlewares = [applyMiddleware(thunk)];

    if (isBrowser() && window.__REDUX_DEVTOOLS_EXTENSION__) {
        middlewares.push(window.__REDUX_DEVTOOLS_EXTENSION__());
    }

    // eslint-disable-next-line prefer-spread
    return compose.apply(null, middlewares);
}

function createAppStore(preloadedState: Partial<StateRoot> = {}) {
    return createStore(rootReducer, preloadedState, createMiddlewares());
}

export default createAppStore;
